import React, {Component} from "react"
import {Container, Header, Loader} from "semantic-ui-react";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {getLocalization, parseMultilineString} from "../utils/localization";
import {setPrevRoute} from "../actions/appHeaderActions";
import {checkIsVerified, EDUCATIONAL_AUTO_ADVANCE_SECONDS, getStepProps, isAnsel} from "../utils/common";
import Steps from "./steps/steps";
import Footer from "./footer";
import {CustomGrid, S3Image} from "./custom-common";
import IMAGE from "../constants/images";

const mapStateToProps = (state, ownProps) => {
    const {user, initialData, benAdmin} = state;
    return {
        user, initialData, benAdmin,
        name: user.firstName,
        lang: user.lang,
        dependents: user.dependents,
        maritalStatus: user.maritalStatus,
        ...ownProps
    }
};

class Frustrations extends Component {
    constructor(props) {
        super(props);
        this.state = {
            stepProps: null
        };
    }

    componentDidMount() {
        const {initialData, user, benAdmin} = this.props;
        checkIsVerified(user, benAdmin, initialData.uiFlow, this.props, initialData.distributionChannel);
        this.props.dispatch(setPrevRoute(this.props.prevRoute));
        this.buildSteps();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.lang !== this.props.lang) {
            this.buildSteps();
        }
    }

    buildSteps = () => {
        const {initialData: {uiFlow, distributionChannel}, lang} = this.props;
        const localization = getLocalization(lang);
        this.setState({stepProps: getStepProps(localization, 0, uiFlow, distributionChannel)});
    }

    render() {
        const {stepProps} = this.state;
        if (!stepProps) {
            return <Container><Loader active={true}/></Container>
        }

        const localization = getLocalization(this.props.lang);
        const strings = localization.frustrations;

        return (
            <React.Fragment>
                <Container className={'contentContainer'}>
                    <Steps stepProps={stepProps} uiFlow={this.props.initialData.uiFlow}/>
                    <CustomGrid container stackable columns={1} centered className={`contentStepsSpacer ${isAnsel() && "largerContentStepsSpacer"}`} fitted={'horizontally'}>
                        <CustomGrid.Column width={8}>
                            <CustomGrid stackable columns={1}>
                                <CustomGrid.Row>
                                    <CustomGrid.Column textAlign={'left'}>
                                        <Header as='h2'>{strings.title}</Header>
                                        <p className={"neutral700Text"}>{parseMultilineString(strings.subTitle)}</p>
                                    </CustomGrid.Column>
                                </CustomGrid.Row>
                                <CustomGrid.Row columns={3}>
                                    <CustomGrid.Column>
                                        <div className={'frustationsImageContainer'}>
                                            <S3Image {...IMAGE.PEACE_OF_MIND_MOM_WITH_CHILD_BG}/>
                                        </div>
                                        <Header as='h4' textAlign="left">{strings.t1}</Header>
                                        <p className="small neutral700Text">{parseMultilineString(strings.d1)}</p>
                                    </CustomGrid.Column>
                                    <CustomGrid.Column>
                                        <div className={'frustationsImageContainer'}>
                                            <S3Image {...IMAGE.PEACE_OF_MIND_PAYMENT}/>
                                        </div>
                                        <Header as='h4' textAlign="left">{strings.t2}</Header>
                                        <p className="small neutral700Text">{parseMultilineString(strings.d2)}</p>
                                    </CustomGrid.Column>
                                    <CustomGrid.Column>
                                        <div className={'frustationsImageContainer'}>
                                            <S3Image {...IMAGE.PEACE_OF_MIND_CONCIERGE}/>
                                        </div>
                                        <Header as='h4' textAlign="left">{strings.t3}</Header>
                                        <p className="small neutral700Text">{parseMultilineString(strings.d3)}</p>
                                    </CustomGrid.Column>
                                </CustomGrid.Row>
                            </CustomGrid>
                        </CustomGrid.Column>
                    </CustomGrid>
                </Container>
                <Footer
                    showTopFooter={true} showCenterData={true}
                    buttonText={localization.next}
                    onClickCallback={() => this.props.history.push(this.props.nextRoute)}
                    autoAdvanceSeconds={EDUCATIONAL_AUTO_ADVANCE_SECONDS}
                />

            </React.Fragment>
        )
    }
}

export default withRouter(connect(mapStateToProps)(Frustrations));
